<script setup lang="ts">
import MainLayout from "views/layouts/MainLayout.vue";
import CarroselTopPeccinLives from "components/Modelos/CarroselTopPeccinLives.vue";
import AllModelsPAginationLives from "components/Modelos/AllModelsPAginationLives.vue";
import BannerAssineHorizontal from "components/HomePage/BannerAssineHorizontal.vue";
import ModelSingleCardLives from "components/Modelos/ModelSingleCardLives.vue";
</script>
<template>
  <MainLayout>
    <div class="slot-body">
      <div class="container">
        <div class="row py-5 align-items-center">
          <div class="col-lg-2 mt-4">
            <h1 class="title">
              {{ translate.title }}
            </h1>
          </div>
          <div class="col-lg-5">
            <span class="subtitle">
              {{ translate.subTitle }}
            </span>
          </div>
          <div class="col-lg-4 search-desktop">
            <ModelSelect
              :modelValue="selected"
              :placeholder="translate.placeHolderSelect"
              name="select-filter-desktop"
              id="select-filter-desktop"
              :options="options"
              @update:model-value="mySelectEvent"
            />
          </div>
        </div>
      </div>

      <div class="block block--gray">
        <div class="container">
          <div class="search-mobile mb-3">
            <ModelSelect
              :modelValue="selected"
              :placeholder="translate.placeHolderSelect"
              name="select-filter-desktop"
              id="select-filter-desktop"
              :options="options"
              @update:model-value="mySelectEvent"
            />
          </div>
          <AllModelsPAginationLives v-if="showPaginate" :models="models" />
          <ModelSingleCardLives v-else :models="models" />
        </div>
      </div>

      <div class="pt-5 pb-5 z-1 crsl-left">
        <div class="title-models pb-5">
          {{ translate.featuredModels }}
        </div>
        <div class="col-lg-12">
          <CarroselTopPeccinLives :posts="posts" />
        </div>
      </div>

      <div class="py-5">
        <BannerAssineHorizontal :path="bannerAssineHorizontal" />
      </div>
    </div>
  </MainLayout>
</template>

<script lang="ts">
import { isMobile } from "../shared/utils/mobile";
import livesTradutor from "tradutors/lives";
import { defineComponent } from "vue";
import { mapState } from "pinia";
import { localeStore } from "stores/locale";
import { userStore } from "stores/user";
import { ModelSelect } from "vue-search-select";
import api from "../../api";

export default defineComponent({
  name: "LivesView",
  components: { ModelSelect },
  computed: {
    ...mapState(localeStore, ["locale"]),
    ...mapState(userStore, ["isActiveUser"]),
    translate: function () {
      if (this.locale === "pt-br") {
        return livesTradutor.portugues;
      } else {
        return livesTradutor.ingles;
      }
    },
  },
  watch: {
    locale: function () {
      this.getBannerAssineHorizontal(true);
    },
  },
  head() {
    return {
      templateParams: {
        subTitle: null, 
        subPage: this.translate.title,
        page_url: window.location.origin + this.$route.fullPath,
        page_description:
          this.locale == "pt-br"
            ? `Mais de 10.000 minutos de vídeos publicados com as mais belas e TOPs modelos.`
            : `More than 10,000 minutes of videos published with the most beautiful and TOP models.`,
        page_image: "/favicon.ico",
        page_keywords:
          "bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site",
        page_locale: this.locale,
        page_url_pt: "https://belladasemana.com.br/pt-br/lives",
        page_url_en: "https://belladasemana.com.br/en/lives",
        page_canonical: "https://belladasemana.com.br"+this.$route.fullPath,        
      },
    };
  },
  data() {
    return {
      isMobile: isMobile(),
      selected: 0,
      posts: {},
      models: {},
      showPaginate: false,
      bannerAssineHorizontal: "",
      options: [],
    };
  },
  created() {
    const lang = ["pt-br", "en"];
    if (lang.indexOf(this.$route.params.locale) === -1) {
      window.location.replace("/");
    }
    this.getModels();
    this.getLastModels();
    this.getBannerAssineHorizontal();
    this.getSelectModels();
  },
  methods: {
    async getModels() {
      api.get("v1/modelos/getLiveModels?order=order").then(({ data }) => {
        this.models = data.modelsArray;
        this.showPaginate = true;
      });
    },
    async getLastModels() {
      api.get("v1/modelos/getLiveModelsLastFive").then(({ data }) => {
        this.posts = data.postsCarroselModels;
      });
    },
    async getBannerAssineHorizontal(changeLanguage = false) {
      if (!sessionStorage.getItem("bannerAssineHorizontal") || changeLanguage)
        api.get(`v1/home/getBannerSuper?mobile=${isMobile()}&language=${this.locale}`).then(({ data }) => {
          this.bannerAssineHorizontal = data.bannerAssineHorizontal;
          sessionStorage.setItem(
            "bannerAssineHorizontal",
            JSON.stringify(this.bannerAssineHorizontal)
          );
        });
      else
        this.bannerAssineHorizontal = JSON.parse(
          sessionStorage.getItem("bannerAssineHorizontal")
        );
    },
    async getSelectModels() {
      api.get("v1/modelos/getLiveModelsSelect").then(({ data }) => {
        this.options = data.modelsArray;
      });
    },
    mySelectEvent(val) {
      this.selected = val;
      if (val === undefined) {
        this.getModels();
      } else {
        api.get("v1/modelos/getModelSelect/" + val).then(({ data }) => {
          this.models = data.modelsArray;
          this.showPaginate = false;
        });
      }
    },
  },
});
</script>

<style scoped lang="css">
.slot-body {
  margin-top: 65px !important;  
  background-color: #fff !important;
}

.title {
  font-family: "Bebas-Neue-Light";
  height: 77px;
  color: #000000;
  font-size: 64px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 77px;
}

.title-models {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 32px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 38px;
}

.subtitle {
  color: #5b5858;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.search-desktop {
  transform: translate(25%);
  z-index: 2;
}

.search-mobile {
  display: none;
}

.crsl-left {
  margin-left: 90px;
}

.block {
  padding: 30px 0;
}

@media screen and (max-width: 992px) {
  .search-desktop {
    transform: unset;
  }
}

@media screen and (max-width: 769px) {
  .title-models {
    font-size: 24px;
    padding-bottom: 20px !important;
  }
  .search-desktop {
    display: none;
  }
  .search-mobile {
    display: block;
  }

  :deep(.selection) {
    background-color: white !important;
  }
  .ui.selection.dropdown {
    line-height: 3em;
  }

  .crsl-left {
    margin-left: 8px;
    padding-top: 20px !important;
  }

  .title {
    font-family: "Bebas-Neue-Light";
    color: #000000;
    font-size: 48px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 58px;
  }
  .z-2 {
    padding-top: 30px !important;
  }
  .subtitle {
    color: #5b5858;
    font-family: "Roboto-Medium";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }

}
</style>
